import { render, staticRenderFns } from "./inventoryOrderDetail.vue?vue&type=template&id=2a9c2770&scoped=true&"
import script from "./inventoryOrderDetail.vue?vue&type=script&lang=js&"
export * from "./inventoryOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./inventoryOrderDetail.vue?vue&type=style&index=0&id=2a9c2770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c2770",
  null
  
)

export default component.exports